// Vue 2 mixin port of vue3/src/features/customer-display/useFullscreenOnTap.js
// (a Composition API composable - Vue 2 here has no Composition API plugin,
// so this is a plain Options API mixin with the identical logic/behavior).
//
// Browsers only allow fullscreen from a user gesture made in THIS window, so
// the display cannot enter it by itself when it opens. Instead the first
// tap/click or key press (Escape excluded: it is how the user leaves
// fullscreen) enters it. `fullscreenSupported`/`isFullscreen` drive the same
// "แตะเพื่อเต็มจอ" hint the Vue 3 version shows.
export default {
  data() {
    return {
      fullscreenSupported: typeof document.documentElement.requestFullscreen === 'function',
      isFullscreen: Boolean(document.fullscreenElement)
    };
  },
  methods: {
    customerDisplaySyncFullscreenState() {
      this.isFullscreen = Boolean(document.fullscreenElement);
    },
    customerDisplayEnterFullscreen() {
      if (!this.fullscreenSupported || document.fullscreenElement) return;
      try {
        const request = document.documentElement.requestFullscreen();
        if (request && typeof request.catch === 'function') request.catch(() => {});
      } catch (error) {
        // Refused by the browser: the hint simply stays visible.
      }
    },
    customerDisplayOnFullscreenClick() {
      this.customerDisplayEnterFullscreen();
    },
    customerDisplayOnFullscreenKeydown(event) {
      if (event.key !== 'Escape') this.customerDisplayEnterFullscreen();
    }
  },
  mounted() {
    document.addEventListener('click', this.customerDisplayOnFullscreenClick);
    document.addEventListener('keydown', this.customerDisplayOnFullscreenKeydown);
    document.addEventListener('fullscreenchange', this.customerDisplaySyncFullscreenState);
    this.customerDisplaySyncFullscreenState();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.customerDisplayOnFullscreenClick);
    document.removeEventListener('keydown', this.customerDisplayOnFullscreenKeydown);
    document.removeEventListener('fullscreenchange', this.customerDisplaySyncFullscreenState);
  }
};
